import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV, LOGO, LOGO_WHITE } from "../data/projects";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onDark = ["/", "/kunststof-kozijnen", "/deuren", "/schuifpuien"].includes(pathname) && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background,box-shadow,padding] duration-500 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl shadow-[0_1px_0_rgba(0,0,0,0.06)] py-3"
          : onDark
          ? "bg-gradient-to-b from-black/60 via-black/25 to-transparent py-5"
          : "bg-white/0 py-5"
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 flex items-center justify-between">
        <Link to="/" data-testid="logo" className="flex items-center gap-3">
          <img src={onDark ? LOGO_WHITE : LOGO} alt="DEKO Kozijnen logo" className="h-10 w-auto transition-opacity duration-300" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-tight transition-colors duration-300 ${
                  onDark
                    ? isActive
                      ? "text-white font-semibold"
                      : "text-white/90 hover:text-white [text-shadow:0_1px_8px_rgba(0,0,0,0.35)]"
                    : isActive
                    ? "text-[#2F3438] font-semibold"
                    : "text-[#222]/75 hover:text-[#2F3438]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/offerte"
            data-testid="nav-offerte-cta"
            className={`hidden sm:inline-flex text-sm px-5 py-2.5 rounded-sm transition-colors duration-300 ${
              onDark ? "bg-white text-[#2F3438] hover:bg-white/90 font-medium" : "bg-[#2F3438] text-white hover:bg-[#222]"
            }`}
          >
            Offerte aanvragen
          </Link>
          <button className={`lg:hidden ${onDark ? "text-white" : "text-[#2F3438]"}`} onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-white border-t border-[#eee]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <Link key={n.to} to={n.to} className="font-display text-xl text-[#2F3438]" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                  {n.label}
                </Link>
              ))}
              <Link to="/offerte" className="mt-2 text-center bg-[#2F3438] text-white px-5 py-3 rounded-sm">Offerte aanvragen</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
